import { defineMessages } from 'react-intl';

type MessageKeys = 'knowledgeSourcePill' | 'allSpaces' | 'allContent';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		knowledgeSourcePill: {
			id: 'knowledgeSourcePill.alt.label',
			defaultMessage: 'Icon for {knowledgeSource}',
			description: 'The alt label for the knowledge source pill',
		},
		allSpaces: {
			id: 'allSpaces.label',
			defaultMessage: 'All spaces',
			description: 'The label for the all spaces filter',
		},
		allContent: {
			id: 'allContent.label',
			defaultMessage: 'All content',
			description: 'The label for the all content filter',
		},
	});

export default message;
